import { Center } from "@chakra-ui/react";
import React from "react";

// import * as S from "./styles";
import { IProps } from "./types";

export const PlaceholderImage: React.FC<IProps> = ({}: // heightPixels,
// widthPixels,
IProps) => (
  // <S.Center>
  <Center
    fontSize="sm"
    color="lightFont"
    // height={`${heightPixels}px`}
    // width={`${widthPixels}px`}
    verticalAlign="bottom"
    objectFit="cover"
  >
    No image
  </Center>
  // </S.Center>
);
